import { motion } from 'framer-motion';
import styled from 'styled-components/macro';
import StyledFlexContainer from './StyledFlexContainer';
const WorkHoverDiv = styled(motion(StyledFlexContainer))`
	justify-content: center;
	align-items: center;
	position: absolute;
	gap: 2rem;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	border-radius: 0.5rem;
	opacity: 0;
	transition: all 0.3s ease;
	div {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		background-color: rgba(0, 0, 0, 0.5);
		color: #fff;
		font-weight: 800;
		cursor: pointer;
		transition: all 0.3s ease;
		svg {
			width: 50%;
			height: 50%;
			/* color: var(--white-color); */
		}
	}
`;

export default WorkHoverDiv;
